module.exports = __webpack_public_path__ + "img/flower.4e77f808.png";